export const renderWithCommand = (number) => (
    number ? number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
)

export const replaceMidd = (string, n) => {
    var rest = string.length - n;
    return string.slice(0, Math.ceil(rest / 2) ) + '*'.repeat(n) + string.slice(-Math.floor(rest / 2) );
}

